import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CopyCheckIcon, CopyXIcon } from '@air/design-icons';
import { contentCollectionClipsWithUploadCountSelector } from '@air/feature-content-collection/redux';
import { Button } from '@air/primitive-button';
import { IconButton } from '@air/primitive-icon-button';
import { useBreakpointsContext } from '@air/provider-media-query';
import { resetSelectedItemsAction, selectAllSelectableItemsAction } from '@air/redux-selected-items';

import { selectedClipsSelector } from '~/store/selectedItems/selectors';

export const ContentCollectionSelectAllButton = memo(() => {
  const { isAboveXLScreen } = useBreakpointsContext();

  const dispatch = useDispatch();
  const totalClips = useSelector(contentCollectionClipsWithUploadCountSelector);
  const selectedClips = useSelector(selectedClipsSelector);
  const allAreSelected = !!totalClips && totalClips === selectedClips.length;

  const onClick = useCallback(() => {
    dispatch(allAreSelected ? resetSelectedItemsAction() : selectAllSelectableItemsAction());
  }, [allAreSelected, dispatch]);

  if (isAboveXLScreen) {
    return (
      <Button
        appearance="ghost"
        color="gray"
        data-testid="CONTENT_COLLECTION_SELECT_ALL"
        disabled={!totalClips}
        onClick={onClick}
        prefix={
          allAreSelected ? <CopyXIcon size="sm" className="-mr-1" /> : <CopyCheckIcon size="sm" className="-mr-1" />
        }
        size="medium"
        className="disabled:bg-transparent disabled:opacity-40"
      >
        {allAreSelected ? 'Deselect all' : 'Select all'}
      </Button>
    );
  }

  return (
    <IconButton
      adsIcon
      appearance="ghost"
      color="gray"
      data-testid="CONTENT_COLLECTION_SELECT_ALL"
      disabled={!totalClips}
      icon={allAreSelected ? CopyXIcon : CopyCheckIcon}
      label={allAreSelected ? 'Deselect all' : 'Select all'}
      onClick={onClick}
      size="medium"
      className="disabled:bg-transparent disabled:opacity-40"
    />
  );
});

ContentCollectionSelectAllButton.displayName = 'ContentCollectionSelectAllButton';
